import { IRoles } from "src/permissions/types/IRoles";

export type VirtualRecepcionistTypes = "phone" | "history" | "contacts" | "voice-mail" | "settings" | "recording";

export interface TabConfigItem {
  value: VirtualRecepcionistTypes;
  label: string;
  icon: React.ReactNode;
  badgeCount?: number;
  roles?: IRoles[];
}

export * from './contacts.types';
